// Exact hostnames only. Use the same name for multiple domains to combine their series.
export const PAGE_VIEW_PROJECTS: Record<string, string> = {
  'app.boxpressd.com': 'Boxpressd Social',
  'shop.boxpressd.com': 'Boxpressd Shop',
};

// Optional deployment annotations, in UTC. Add entries from your deployment history.
export const PAGE_VIEW_DEPLOYMENTS: {
  timestamp: string;
  hostname: string;
  label: string;
}[] = [];
